import { Outlet, Navigate, useLocation } from "react-router-dom";
import React from "react";

const PrivateRoutes = () => {
  const auth = localStorage.getItem("isAuthenticated");
  const location = useLocation();

  return auth ? <Outlet /> : <Navigate to="/register" state={{ from: location.pathname }} />;
};

export default PrivateRoutes;
